module.exports = __webpack_public_path__ + "static/media/bfBadge.8ebfa4c7.svg";